import React from 'react';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { TitleFeatured } from '@/components/typography';
import OffersList from '@/features/oferta/components/OffersList/OffersList';
import LayoutInternal from '@/layout/LayoutInternal/LayoutInternal';

export interface OfertaIndexProps {
  data: OfferDataType;
}

const OfertaIndex = ({ data }: OfertaIndexProps) => {
  const { offers } = data;
  const breadcrumbs: BreadcrumbType = [{ text: 'Ofertas' }];
  return (
    <LayoutInternal breadcrumbs={breadcrumbs} navbar="sticky">
      <WhitePaper col={12}>
        <TitleFeatured title="Ofertas" as="h1" />
        <OffersList offers={offers} />
      </WhitePaper>
    </LayoutInternal>
  );
};

export default OfertaIndex;
